import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {BlocksComponent} from 'projects/blocks/blocks.component';
import {Column} from '@paperlessio/sdk/api/models';

@Component({
  selector: 'app-column',
  templateUrl: '../../blocks.component.html',
  styleUrls: [
    '../../blocks.component.scss',
    './column.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ColumnComponent extends BlocksComponent {
  @Input() block: Column | any;
}
